import { FC } from 'react';
import { numberFormat, Text } from '@mofid-securities/uikit';

interface ITransactionCardAmountProps {
  amount?: number;
}

export const TransactionCardAmount: FC<ITransactionCardAmountProps> = ({
  amount,
}) => {
  return amount ? (
    <Text
      className="flex items-baseline gap-x-1"
      color="gray-120"
      size="sm"
      weight="medium"
    >
      {numberFormat(amount)}
      <Text className="!font-regular" color="gray-90" size="xs">
        ریال
      </Text>
    </Text>
  ) : null;
};
